// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"80a75bee","18":"990dc139","33":"ac3dd318","323":"9b879204"}[chunkId] + ".chunk.css";
};